import { MediaQueries, theme } from '@hhgtech/hhg-components'
import {
  Badge,
  BadgeProps,
  Button,
  Text,
} from '@hhgtech/hhg-components/mantine'

import { useCurrentUrl } from 'hooks/useCurrentUrl'
type _BadgeProps = {
  name: string
  index: number
  onSelect(name: string): void
  applyH1?: boolean
} & BadgeProps
export const _Badge = ({
  name,
  index,
  onSelect,
  applyH1,
  ...rest
}: _BadgeProps) => {
  const currentUrl = useCurrentUrl()

  return (
    <Badge
      styles={{
        root: {
          padding: '8px 16px',
          backgroundColor: theme.colors.neutral50,
          border: 'none',
          height: 40,
          [MediaQueries.mbDown]: {
            padding: '5px 12px',
            height: 32,
          },
        },
        inner: {
          textTransform: 'capitalize',
        },
      }}
      size="xl"
      radius="xl"
      {...rest}
    >
      <Button
        size="sm"
        variant="white"
        data-event-category="Spotlight"
        data-event-action={`Tag Click ${index + 1}`}
        data-event-label={currentUrl}
        onClick={() => onSelect(name)}
        style={{ padding: 0, background: 'inherit' }}
      >
        <Text
          size="s3"
          as={applyH1 ? 'h1' : 'p'}
          weight="semiBold"
          color={theme.colors.gray600}
        >
          {name}
        </Text>
      </Button>
    </Badge>
  )
}
